import { IInterviewParticipant } from 'app/shared/model/interview-participant.model';
import { IUser } from 'app/shared/model/user.model';
import { IRecordedInterview } from 'app/shared/model/recorded-interview.model';
import { InterviewsStatus } from 'app/shared/model/enumerations/interviews-status.model';

export interface IInterview {
  id?: number;
  name?: string | null;
  interviewTime?: number | null;
  duration?: number | null;
  statusType?: InterviewsStatus | null;
  dailyCoLink?: string | null;
  daliyCoRoom?: string | null;
  interviewParticipants?: IInterviewParticipant[] | null;
  user?: IUser | null;
  recordedInterview?: IRecordedInterview | null;
}

export const defaultValue: Readonly<IInterview> = {};
